import {FC} from "react";
import {Box, MenuItem, Select} from "@mui/material";
import {SearchBox} from "@buildwitt/shapeshift-common/v2/searchBox";
import {NotesFilterProps} from "@buildwitt/shapeshift-common/v2/notesLibrary";
import {makeStyles} from "tss-react/mui";
import {useSSTranslation} from "@/i18n/useSSTranslation";

const useStyles = makeStyles()((theme) => ({
	filterSelect:{
		minWidth: "250px",
		"& .MuiSelect-select > span": {
			visibility: "visible"
		}
	},
	emptyMenuItem:{}
}));

interface IPropsCustom {
	contentTypes?: string[]
}

export type IProps = NotesFilterProps & IPropsCustom;

const EMPTY_CONTENT_TYPE = "Content Type"

export const NotesFilter:FC<IProps> = ({onChange, searchValue, contentTypes = [], ...baseProps}) => {
	const {classes} = useStyles();
	const {t} = useSSTranslation()
	const filterBy = searchValue?.notesGetAdditionalData?.contentType || EMPTY_CONTENT_TYPE

	return <Box {...baseProps}>
		<SearchBox
			value={searchValue.searchTerm}
			onChange={e => onChange({...searchValue, searchTerm: e.target.value ?? ""})}
		/>
		<Select value={filterBy} className={classes.filterSelect} variant="outlined" onChange={value => onChange({...searchValue, notesGetAdditionalData: value.target.value !== EMPTY_CONTENT_TYPE ? {contentType: value.target.value}: undefined})}>
			<MenuItem value={EMPTY_CONTENT_TYPE}><span className={classes.emptyMenuItem}>{t("page_notes_all", "All")}</span></MenuItem>
			{contentTypes.map((item, idx) => {
				return <MenuItem key={idx} value={item}>{t(`course_category_${item}`, item)}</MenuItem>
			})}
		</Select>
	</Box>
}